import { render, staticRenderFns } from "./ShareFile.vue?vue&type=template&id=52adb534&"
import script from "./ShareFile.vue?vue&type=script&lang=js&"
export * from "./ShareFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports